import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {StorageServiceProvider} from "../storage-service/storage-service";
import {ConfigServiceProvider} from "../config-service/config-service";

/*
  Generated class for the GroupServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GroupServiceProvider {

  constructor(public http: HttpClient, private storageService: StorageServiceProvider, private configService: ConfigServiceProvider) {
  }

  load() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('groups'))
        .toPromise()
        .then((response) => {
          return this.storageService.setObject('groups', response);
        }, reason => {
          console.error(reason);
          reject();
        })
        .then(() => {
          resolve()
        }, reason => reject());
    });
  }

  getGroups() {
    return this.storageService.getObject('groups');
  }

}



// WEBPACK FOOTER //
// ./src/modules/core/services/group-service/group-service.ts